import { connect } from "react-redux";
import Manual from "./Manual";

const mapState = ({ auth, auth_dialer }) => ({
    service: auth_dialer.serviceDialer,
    lang: auth.lang,
});

export default connect(mapState)(Manual);
